import { createRouter, createWebHistory } from "vue-router";

import BaseLayout from "@/components/BaseLayout";

export const constantRoutes = [
  // 项目默认跳转根据域名匹配  千鸟和云看看不同
  // 千鸟项目默认跳转
  {
    path: "/",
    component: BaseLayout,
    redirect: "first",
    children: [
      {
        name: "LeftList",
        path: "first",
        component: () => import("@/views/leftlist/index"),
      },
    ],
  },
  {
    path: "/dist",
    component: BaseLayout,
    redirect: "first",
    children: [
      {
        name: "LeftList",
        path: "first",
        component: () => import("@/views/leftlist/index"),
      },
    ],
  },
  {
    path: "/dist/lang/index",
    component: BaseLayout,
    children: [
      {
        name: "Lang",
        path: "/dist/lang/index",
        component: () => import("@/views/leftlist/index"),
      },
    ],
  },

  {
    path: "/dist/content",
    component: BaseLayout,
    children: [
      {
        name: "Content",
        path: "index/:data",
        component: () => import("@/views/content/index"),
      },
    ],
  },

  {
    name: "CustomerService",
    path: "/dist/customerService",
    component: () => import("@/views/customerService/index"),
    meta: { title: "customerService" },
  },

  {
    name: "Form",
    path: "/dist/form",
    component: () => import("@/views/form/index"),
  },
  {
    name: "Contact",
    path: "/dist/contact",
    component: () => import("@/views/other/contact"),
  },
  {
    name: "Cancellation",
    path: "/dist/cancellation",
    component: () => import("@/views/other/cancellation"),
  },
  {
    name: "PlayBack",
    path: "/dist/playback",
    component: () => import("@/views/other/playback"),
  },
  // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
  // 智能客服对话框
  {
    name: "AiVoiceFAQ",
    path: "/dist/aiVoiceFAQ",
    component: () => import("@/views/aiVoiceFAQ/index"),
    meta: { title: "小度AI智能语音服务FAQ" },
  },
  {
    name: "CustomerServiceChat",
    path: "/dist/CustomerServiceChat",
    component: () => import("@/views/customerServiceChat/index"),
    meta: { title: "customerService" },
  },

  //   云看看项目默认跳转
  // {
  //   path: '/',
  //   name: 'App',
  //   component: App,
  //   meta: { title: '首页' },
  //   redirect: '/dist/cloudSee/help',
  // },
  // {
  //   path: '/dist',
  //   component: App,
  //   redirect: '/dist/cloudSee/help',
  // },

  // 云看看
  {
    name: "cloudSeeCustomerService",
    path: "/dist/cloudSeeCustomerService",
    component: () => import("@/views/cloudSee/customerService/index"),
    meta: { title: "customerService" },
  },
  {
    name: "CloudSeeHelp",
    path: "/dist/cloudSee/help",
    component: () => import("@/views/cloudSee/help/index"),
    meta: { title: "pageTitle" },
  },
  // 视频播放
  {
    name: "CloudSeePlayBack",
    path: "/dist/cloudSee/playback",
    component: () => import("@/views/cloudSee/playback/index"),
    meta: { title: "pageTitle" },
  },
  // 问题详情
  {
    name: "CloudSeeProblem",
    path: "/dist/cloudSee/problem",
    component: () => import("@/views/cloudSee/problem/index"),
    meta: { title: "pageTitle" },
  },
  {
    name: "CloudSeeProblemDetail",
    path: "/dist/cloudSee/problemDetail",
    component: () => import("@/views/cloudSee/problem/detail"),
    meta: { title: "pageTitle" },
  },

  // 飞利浦隐私政策
  {
    name: "PhilipsPrivacy",
    path: "/dist/agreed/philipsPrivacy",
    component: () => import("@/views/htmlPage/philips-privacy/index"),
    meta: { title: "privacyPolicyTitle" },
  },
  // 飞利浦用户协议
  {
    name: "PhilipsUserTerms",
    path: "/dist/agreed/philipsUserTerms",
    component: () => import("@/views/htmlPage/philips-userTerms/index"),
    meta: { title: "usertermsTitle" },
  },
  // 飞利浦自动续费协议
  {
    name: "PhilipsAutoRenew",
    path: "/dist/agreed/philipsAutoRenew",
    component: () => import("@/views/htmlPage/philips-autoRenew/index"),
    meta: { title: "philipsAutoRenewTitle" },
  },
  //  飞利浦云服务购买(云存储购买协议)
  {
    name: "PhilipsCloudService",
    path: "/dist/agreed/philipsCloudService",
    component: () => import("@/views/htmlPage/philips-cloudServiceDesc/index"),
    meta: { title: "philipsCloudServiceTitle" },
  },

  // 云看看自动续费协议
  {
    name: "cloudSeeAutoRenew",
    path: "/dist/agreed/cloudSeeAutoRenew",
    component: () => import("@/views/htmlPage/cloudSee-autoRenew/index"),
    meta: { title: "philipsAutoRenewTitle" },
  },
  // 云看看用户协议
  {
    name: "UserTerms",
    path: "/dist/agreed/userTerms",
    component: () => import("@/views/htmlPage/userTerms/index"),
    meta: { title: "usertermsTitle" },
  },
  // 云看看隐私政策（含萤视通）
  {
    name: "PrivacyPolicy",
    path: "/dist/agreed/privacyPolicy",
    component: () => import("@/views/htmlPage/privacyPolicy/index"),
    meta: { title: "privacyPolicyTitle" },
  },
  // 开心看用隐私政策
  {
    name: "HapPrivacyPolicy",
    path: "/dist/agreed/hapPrivacyPolicy",
    component: () => import("@/views/htmlPage/hap-privacyPolicy/index"),
    meta: { title: "privacyPolicyTitle" },
  },
  // 开心看用户协议
  {
    name: "HapUserTerms",
    path: "/dist/agreed/hapUserTerms",
    component: () => import("@/views/htmlPage/hap-userterms/index"),
    meta: { title: "usertermsTitle" },
  },

  // 千鸟鸿蒙隐私政策
  {
    name: "BirdsHarmonyOSPrivacy",
    path: "/dist/agreed/birdsHarmonyOSPrivacy",
    component: () =>
      import("@/views/htmlPage/birds-harmonyOS-privacyPolicy/index"),
    meta: { title: "privacyPolicyTitle" },
  },
  // 千鸟隐私政策
  {
    name: "BirdsPrivacy",
    path: "/dist/agreed/birdsPrivacy",
    component: () => import("@/views/htmlPage/birds-privacyPolicy/index"),
    meta: { title: "privacyPolicyTitle" },
  },
  // 千鸟用户协议
  {
    name: "BirdsUserTerms",
    path: "/dist/agreed/birdsUserTerms",
    component: () => import("@/views/htmlPage/birds-userterms/index"),
    meta: { title: "usertermsTitle" },
  },
  // 千鸟自动续费协议
  {
    name: "birdsAutoRenew",
    path: "/dist/agreed/birdsAutoRenew",
    component: () => import("@/views/htmlPage/birds-autoRenew/index"),
    meta: { title: "philipsAutoRenewTitle" },
  },
  // 千鸟 智能侦测服务协议
  {
    name: "BirdsDetectionService",
    path: "/dist/agreed/birdsDetectionService",
    component: () => import("@/views/htmlPage/birds-detectionService/index"),
    meta: { title: "birdsDetectionServiceTitle" },
  },
  // 千鸟 全能ai报警服务协议
  {
    name: "BirdsAIDetectionService",
    path: "/dist/agreed/birdsAIDetectionService",
    component: () => import("@/views/htmlPage/birds-aiDetectionService/index"),
    meta: { title: "birdsAIDetectionServiceTitle" },
  },
  // 千鸟 智能侦测服自动续费协议
  {
    name: "BirdsDetectionAutoRenew",
    path: "/dist/agreed/birdsDetectionAutoRenew",
    component: () => import("@/views/htmlPage/birds-detectionAutoRenew/index"),
    meta: { title: "birdsDetectionAutoRenewTitle" },
  },
  // 千鸟 ai语音服务协议
  {
    name: "BirdsAiServiceDesc",
    path: "/dist/agreed/birdsAiServiceDesc",
    component: () => import("@/views/htmlPage/birds-ai-serviceDesc/index"),
    meta: { title: "philipsCloudServiceTitle" },
  },
  // 千鸟 ai语音自动续费协议
  {
    name: "BirdsAiAutoRenew",
    path: "/dist/agreed/birdsAiAutoRenew",
    component: () => import("@/views/htmlPage/birds-ai-autoRenew/index"),
    meta: { title: "philipsAutoRenewTitle" },
  },

  {
    name: "CardRecharge",
    path: "/dist/birds/checkCards",
    component: () => import("@/views/birds/check-cards/index"),
    meta: { title: "rechargeTitle" },
  },
  // 个人信息清单及SDK共享清单
  {
    name: "InfoList",
    path: "/dist/birds/infoList",
    component: () => import("@/views/birds/info-list/index"),
    meta: { title: "infoListTitle" },
  },
  // 用户身份信息
  {
    name: "UserInfo",
    path: "/dist/birds/userInfo",
    component: () => import("@/views/birds/user-info/index"),
    meta: { title: "userInfoTitle" },
  },
  // 接口请求
  {
    name: "ApiPage",
    path: "/dist/apiPage",
    component: () => import("@/views/apiPage/apiPage"),
    meta: { title: "userInfoTitle" },
  },
];

const create = () =>
  createRouter({
    mode: "history", // require service support
    base: "/dist/",
    history: createWebHistory(),
    routes: constantRoutes,
  });

const router = create();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = create();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
